<ul class="tag-cloud">
    @for (keyword of keywords; track keyword) {
        <li class="tag">{{keyword}}</li>
    }
</ul>
